import { render, staticRenderFns } from "./lesson.vue?vue&type=template&id=481e8524&"
import script from "./lesson.vue?vue&type=script&lang=ts&"
export * from "./lesson.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "lesson.vue"
export default component.exports